<template>
  <div class="dark-theme-wrapper">
    <div
      class="container d-flex justify-content-center align-items-center h-100"
    >
      <div class="register-card fade-in">
        <h2 class="main-title text-center mb-4">NOVÁ REGISTRACE</h2>
        <div class="separator mx-auto mb-5"></div>

        <div v-if="successMessage" class="text-center fade-in">
          <div class="alert-box success mb-4">✅ {{ successMessage }}</div>
          <p class="text-muted">
            Na váš email jsme odeslali potvrzovací odkaz. <br />
            Pro aktivaci účtu na něj prosím klikněte.
          </p>
          <button
            @click="$router.push('/login')"
            class="btn-red-glow w-100 mt-3"
          >
            PŘEJÍT NA PŘIHLÁŠENÍ
          </button>
        </div>

        <form v-else @submit.prevent="registerUser">
          <div class="mb-4">
            <label class="form-label">PŘEZDÍVKA (Jméno v tabulce)</label>
            <input
              type="text"
              v-model="username"
              class="form-control dark-input"
              placeholder="Např. PepaNovak"
              required
            />
          </div>

          <div class="mb-4">
            <label class="form-label">EMAIL</label>
            <input
              type="email"
              v-model="email"
              class="form-control dark-input"
              placeholder="name@example.com"
              required
            />
          </div>

          <div class="mb-5">
            <label class="form-label">HESLO</label>
            <div class="password-wrapper">
              <input
                :type="passwordVisible ? 'text' : 'password'"
                v-model="password"
                class="form-control dark-input with-icon"
                placeholder="Minimálně 6 znaků"
                required
              />
              <span
                class="password-toggle-icon"
                @click="passwordVisible = !passwordVisible"
                role="button"
                title="Zobrazit/Skrýt heslo"
              >
                <svg
                  v-if="passwordVisible"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                  ></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </span>
            </div>
          </div>

          <button type="submit" class="btn-red-glow w-100">
            VYTVOŘIT ÚČET
          </button>
        </form>

        <div v-if="!successMessage" class="text-center mt-4">
          <p class="login-text">
            Už máte účet?
            <router-link to="/login" class="login-link">
              Přihlaste se zde
            </router-link>
          </p>
        </div>

        <transition name="fade">
          <div v-if="errorMessage" class="alert-box error mt-4">
            ⚠️ {{ errorMessage }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db } from "../auth";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";

export default {
  name: "UserRegister",
  data() {
    return {
      username: "",
      email: "",
      password: "",
      errorMessage: "",
      successMessage: "", // Nová proměnná pro úspěch
      passwordVisible: false,
    };
  },
  methods: {
    async registerUser() {
      this.errorMessage = "";
      this.successMessage = "";

      try {
        // 1. Vytvoření uživatele
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          this.email,
          this.password
        );
        const user = userCredential.user;

        // 2. Uložení do databáze
        await setDoc(doc(db, "users", user.uid), {
          username: this.username,
          email: this.email,
          role: "user",
          jokerUsed: false,
          totalPoints: 0, // Inicializace bodů
          createdAt: new Date(),
        });

        // 3. Odeslání ověřovacího emailu (Nastavíme češtinu)
        auth.languageCode = "cs";
        await sendEmailVerification(user);

        console.log("✅ Uživatel zaregistrován a email odeslán:", user.email);

        // 4. OKAMŽITÉ ODHLÁŠENÍ (Aby nemohl vstoupit bez ověření)
        await signOut(auth);

        // 5. Zobrazení úspěchu v UI (Formulář zmizí díky v-if)
        this.successMessage =
          "Registrace úspěšná! Zkontrolujte prosím svůj email a potvrďte registraci.";
      } catch (error) {
        console.error("❌ Chyba při registraci:", error);

        let msg = error.message;
        if (error.code === "auth/email-already-in-use")
          msg = "Tento email je již registrován.";
        if (error.code === "auth/weak-password")
          msg = "Heslo musí mít alespoň 6 znaků.";
        if (error.code === "auth/invalid-email")
          msg = "Neplatný formát emailu.";

        this.errorMessage = msg;
      }
    },
  },
};
</script>

<style scoped>
/* =========================================
   DARK THEME STYLING
   ========================================= */

.dark-theme-wrapper {
  background-color: #000000;
  min-height: 100vh;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

/* Karta */
.register-card {
  background: #111;
  border: 1px solid #333;
  border-radius: 15px;
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 0 30px rgba(220, 53, 69, 0.15);
}

/* Typografie */
.main-title {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
}

.separator {
  width: 60px;
  height: 4px;
  background-color: #dc3545;
  border-radius: 2px;
}

/* Inputy */
.form-label {
  font-size: 0.8rem;
  font-weight: bold;
  color: #888;
  letter-spacing: 1px;
  margin-bottom: 8px;
  display: block;
}

.dark-input {
  background-color: #000;
  border: 1px solid #444;
  color: #fff;
  padding: 12px 15px;
  border-radius: 8px;
  width: 100%;
  transition: all 0.3s ease;
}

/* Odsazení textu v inputu kvůli ikonce */
.dark-input.with-icon {
  padding-right: 45px;
}

.dark-input:focus {
  border-color: #dc3545;
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.25);
}

.dark-input::placeholder {
  color: #444;
}

/* Styly pro kukátko */
.password-wrapper {
  position: relative;
  width: 100%;
  display: block;
}

.password-toggle-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  z-index: 20; /* Důležité: nad inputem */
}

.password-toggle-icon:hover {
  color: #dc3545;
}

/* Tlačítka */
.btn-red-glow {
  background: linear-gradient(135deg, #a71d2a 0%, #dc3545 100%);
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
}

.btn-red-glow:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.6);
}

/* Odkazy */
.login-text {
  color: #888;
  font-size: 0.9rem;
}

.login-link {
  color: #dc3545;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.2s;
}

.login-link:hover {
  color: #ff6b6b;
  text-decoration: underline;
}

/* Alert Box */
.alert-box {
  padding: 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  text-align: center;
  font-weight: bold;
}

.alert-box.error {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
  color: #ff6b6b;
}

.alert-box.success {
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid #28a745;
  color: #28a745;
}

/* Animace */
.fade-in {
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
